module.exports = __webpack_public_path__ + "static/media/euro.ab9f3879.png";